(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /* BISOU PRODUCT PAGE CUSTOMIZATION — GIFT NOTE
     Modal behavior and line item property updates for the native product form.
  */
  (() => {
    const giftNotes = document.querySelectorAll('[data-bisou-gift-note]');

    giftNotes.forEach((giftNote) => {
      const trigger = giftNote.querySelector('[data-bisou-gift-note-open]');
      const modal = giftNote.querySelector('[data-bisou-gift-note-modal]');
      const saveButton = giftNote.querySelector('[data-bisou-gift-note-save]');
      const closeButtons = giftNote.querySelectorAll('[data-bisou-gift-note-close]');
      const fields = giftNote.querySelectorAll('[data-bisou-gift-note-field]');
      const propertyInputs = giftNote.querySelectorAll('[data-bisou-gift-note-property]');
      let lastFocusedElement = null;

      if (!trigger || !modal || !saveButton) return;

      const getField = (key) => giftNote.querySelector(`[data-bisou-gift-note-field="${key}"]`);
      const getProperty = (key) => giftNote.querySelector(`[data-bisou-gift-note-property="${key}"]`);
      const focusableSelector = 'button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])';

      const syncSavedState = () => {
        const hasValue = Array.from(propertyInputs).some((input) => input.value.trim() !== '' && !input.disabled);
        giftNote.classList.toggle('is-saved', hasValue);
        trigger.setAttribute('aria-pressed', hasValue ? 'true' : 'false');
        const savedLabel = giftNote.querySelector('.bisou-product-gift-note__saved');
        if (savedLabel) savedLabel.hidden = !hasValue;
      };

      const openModal = () => {
        lastFocusedElement = document.activeElement;
        modal.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('bisou-gift-note-open');
        const firstField = getField('from') || modal.querySelector(focusableSelector);
        window.setTimeout(() => firstField?.focus(), 20);
      };

      const closeModal = () => {
        modal.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('bisou-gift-note-open');
        lastFocusedElement?.focus?.();
      };

      const saveNote = () => {
        let hasAnyValue = false;

        fields.forEach((field) => {
          const key = field.getAttribute('data-bisou-gift-note-field');
          const propertyInput = getProperty(key);
          if (!propertyInput) return;

          const value = field.value.trim();
          propertyInput.value = value;
          propertyInput.disabled = value === '';
          if (value !== '') hasAnyValue = true;
        });

        if (!hasAnyValue) {
          propertyInputs.forEach((input) => {
            input.value = '';
            input.disabled = true;
          });
        }

        syncSavedState();
        closeModal();
      };

      trigger.addEventListener('click', openModal);
      saveButton.addEventListener('click', saveNote);
      closeButtons.forEach((button) => button.addEventListener('click', closeModal));

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => !element.disabled && element.offsetParent !== null);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      syncSavedState();
    });
  })();
  /* END BISOU PRODUCT PAGE CUSTOMIZATION — GIFT NOTE */
  } catch(e) { console.error(e); }
})();

})();
